import SectionHeading from "./SectionHeading";
import { guideSteps } from "@/mocks/site";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          eyebrow="追更指南 · 四步上手"
          title="第一次来，按这个顺序逛就对了"
          desc="抖漫把「找、追、筛、收藏」四件事放在同一页里。照着下面四步操作，几分钟就能建立起自己的追更清单。"
        />

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {guideSteps.map((step, index) => (
            <li
              key={step.step}
              className="relative flex flex-col gap-3 rounded-lg border border-background-200/70 bg-background-100/50 p-5 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-2xl">
                  <i className={step.icon} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-4xl text-background-300 leading-none">{step.step}</span>
              </div>
              <h3 className="font-medium text-foreground-950 text-base md:text-lg leading-snug">{step.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{step.desc}</p>
              {index < guideSteps.length - 1 && (
                <i
                  className="hidden lg:flex absolute top-1/2 -right-3 -translate-y-1/2 w-6 h-6 items-center justify-center text-background-400 ri-arrow-right-s-line text-xl"
                  aria-hidden="true"
                ></i>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}